import React from 'react';

import { View } from 'react-native';

import { placeHolderPerson } from 'assets/images';

import { CastPerson } from 'store/railsBuilder/reducer.types';

import { isWeb } from 'utils/responsiveness';

import BaseTileImage from 'components/BaseTileImage';
import {
    AspectRatio,
    ImageContentType,
    ImageSize,
    ImageType,
} from 'components/NagraImage/types';
import Text, { ETextCategory, ETextColor } from 'components/Text';

import styles from './style';

type Props = {
    item: CastPerson;
    testID?: string;
};

const PersonRibbon = React.forwardRef<View, Props>(
    ({ item, testID }: Props, ref) => {
        return (
            <View
                ref={ref}
                testID={testID}
                style={styles.container}
                accessibilityLabel={item.name}
                accessibilityRole="text"
                {...(isWeb && { tabIndex: 0 })}
                accessible
            >
                <BaseTileImage
                    style={styles.image}
                    placeHolder={placeHolderPerson}
                    backupSourceResizeMode="contain"
                    resizeMode="cover"
                    contentId={item.id}
                    contentType={ImageContentType.PERSON}
                    imageType={ImageType.CHARACTER}
                    aspect={AspectRatio.PERSON}
                    width={ImageSize.EXTRA_LARGE_CHANNEL_LOGO.width}
                    aria-hidden={isWeb}
                />
                <Text
                    category={ETextCategory.body2}
                    color={ETextColor.neutral}
                    style={styles.actorName}
                    numberOfLines={1}
                    center
                    bold
                >
                    {item.name}
                </Text>
            </View>
        );
    },
);

export default PersonRibbon;
